import { IconCamera, IconEdit } from '@tabler/icons-react'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'
import { getApi } from '../../api/call.api'
import { urlApi } from '../../api/url.api'
import Layout from '../../layout/Layout'
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller'
import UpdateInfluencerModal from './Components/UpdateInfluencerModal'
// import PlatformGraph from '../PlatformDashboard/Components/PlatformGraph'
// import PromotionLinkCard from '../Promotions/Components/PromotionLinkCard'

const InfluencerProfile = () => {
    const { influencerId } = useParams();
    const [influencerDetails, setInfluencerDetails] = useState(null);

    async function getInfluencerDetails() {
        loadingShow();
        let resp = await getApi(urlApi.influencerDetails + influencerId);
        loadingHide();
        if (resp.responseCode === 200) {
            setInfluencerDetails(resp.data);
        } else {
            toast.error(resp.message);
        }
    }

    useEffect(() => {
        getInfluencerDetails();
    }, [influencerId]);

    return (
        <Layout>

            <div className='global-gradient p-2 rounded-2xl mb-3'>
                <div className="flex justify-between items-center p-1 mb-2">
                    <p className='mb-0 text-sm font-medium text-white'>Influencer Profile</p>
                    <UpdateInfluencerModal buttonComponent={<button title='Edit Influencer Details'> <IconEdit size={20} color='#9747FF' /> </button>} callback={() => getInfluencerDetails()} influencerData={influencerDetails} key={influencerDetails?._id} />
                </div>
                <hr className="!my-3" />
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-3">
                    <div className="profile-details global-gradient p-3 rounded-2xl flex gap-3 items-center grid-cols-1 border border-primary text-white">
                        <div className="relative w-fit">
                            <img src={influencerDetails?.channelLogo || "https://upload.wikimedia.org/wikipedia/commons/a/ac/Default_pfp.jpg"} alt="" className='w-full  min-w-[60px]  max-w-[150px] rounded-full aspect-square  object-cover' />
                        </div>
                        <div className='grow overflow-hidden'>
                            <p className="mb-1 text-lg font-medium">{influencerDetails?.channelName}</p>
                            <p className="mb-1 text-[var(--secondary-text)] break-words">{influencerDetails?.email}</p>
                            <p className="mb-0">{influencerDetails?.phone}</p>
                        </div>
                    </div>

                    <div className="profile-inputs col-span-2">
                        <p className='mb-2 text-sm font-medium text-white'>Personal Details</p>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <div className="col-span-1">
                                <input type="text" readOnly disabled className="border-2 border-gray-300 rounded-md p-2 w-full" defaultValue={influencerDetails?.name} placeholder='Name' />
                            </div>
                            <div className="col-span-1">
                                <input type="text" readOnly disabled className="border-2 border-gray-300 rounded-md p-2 w-full" placeholder="Email" defaultValue={influencerDetails?.email} />
                            </div>
                            <div className="col-span-1">
                                <input type="text" readOnly disabled className="border-2 border-gray-300 rounded-md p-2 w-full" placeholder="Mobile" defaultValue={influencerDetails?.phone} />
                            </div>
                            <div className="col-span-1">
                                <input type="text" readOnly disabled className="border-2 border-gray-300 rounded-md p-2 w-full" placeholder="Location" defaultValue={influencerDetails?.address} />
                            </div>
                            <div className="col-span-2">
                                <textarea name="" readOnly disabled className='w-full p-2' placeholder='Notes' id="" defaultValue={influencerDetails?.note}></textarea>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div className="mb-3">
                {/* <PlatformGraph /> */}
            </div>

            {
                // [1, 2, 3, 4].map((item, index) => {
                //     return (
                //         <PromotionLinkCard key={index} />
                //     )
                // })
            }

        </Layout>
    )
}

export default InfluencerProfile